import React, { Fragment } from 'react';
import { string } from 'prop-types';
import useStyles from 'hooks/useStyles';
import { useDispatch } from 'react-redux';

import SnapaskHeader from 'components/SnapaskHeader';
import SnapaskFooter from 'components/SnapaskFooter';
import { BackIcon } from 'components/Icon';

import { goBack } from 'reduxModules/navigation/action';
import ContentByInstructor from 'routes/instructor-profile/components/ContentByInstructor';

import styles from './ContentListByInstructor.scss';

function ContentListByInstructor({ contentType }) {
  useStyles(styles);
  const dispatch = useDispatch();

  return (
    <Fragment>
      <SnapaskHeader />
      <div className={styles.root}>
        <div
          onClick={() => dispatch(goBack())}
          className={styles.backIconWrapper}
        >
          <BackIcon />
        </div>
        <ContentByInstructor contentType={contentType} />
      </div>
      <SnapaskFooter />
    </Fragment>
  );
}
ContentListByInstructor.propTypes = {
  contentType: string.isRequired,
};
export default ContentListByInstructor;
